import { ChevronDown } from '@aktiia/design-system';
import cx from 'classnames';

import { ISelectInputProps } from './types';

export const SelectInput = ({ value, onChange, options, placeholder, className }: ISelectInputProps) => (
  <div className="flex flex-1 relative items-center">
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder ?? undefined}
      className={cx(className, 'h-[48px] pr-12 cursor-pointer appearance-none')}
    >
      <option selected disabled hidden className="hidden" value="">
        {placeholder}
      </option>
      {Object.entries(options).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>

    <div className="absolute cursor-pointer pointer-events-none right-4">
      <ChevronDown />
    </div>
  </div>
);
